import React, { useContext, useEffect, useState } from "react";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import service from "../../../../api/services";
import organisms from "../../../../components/organisms";
import {
  Default_Page_Limit,
  Default_Page_Number,
} from "../../../../constants/defaultValues";
import { HeaderHeading } from "../../../../Context";
import { DropdownOption, PendingList, StoreData, TParams, TSelectedProduct } from "./interface";
import molecules from "../../../../components/molecules";
import atoms from "../../../../components/atoms";
import { useToasts } from "react-toast-notifications";
import constant from "../../../../constants/constant";

const { OrgMovementPending } = organisms;
const { CreateModal,ConfirmationModal } = molecules;
const { Select } = atoms;

const Index = () => {
  const { addToast } = useToasts();
  const { setHeader }: any = useContext(HeaderHeading);
  const [pendingListing, setPendingListing] = useState<PendingList>();
  const [showModal, setShowModal] = useState<string>('');
  const [selectedStoreId, setSelectedStoreId] = useState<TSelectedProduct>({
    procurement_item_id: '',
    pickup_store_id: ''
  });

  const [params, setParams] = useState<TParams>({
    page: Default_Page_Number,
    limit: Default_Page_Limit,
    search: "",
  });
  const [storeData, setStoreData] = useState<DropdownOption[]>([]);

  const updateParams = (name: string, value: number | string) => {
    if (name === "search") {
      setParams((prevState) => ({
        ...prevState,
        [name]: value as string,
        page: Default_Page_Number,
      }));
    } else {
      setParams((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  //function to get the pending movement list
  const getPendingList = async () => {
    try {
      const response = await service.movementService.getPendingList(params);
      if (response?.status === 200 || response?.status === 201) {
        setPendingListing(response?.data);
      }
    } catch (error) {
      console.error("error>>>", error);
    }
  };

  //function to get the dropdown
  const getDropDown = (response: StoreData[] | undefined): DropdownOption[] => {
    if (!response) return [];

    return response.map((value) => ({
      value: value.id,
      label: `${value?.store_location} (Total: ${value.total_product_count}) (Impaired: ${value.impair_product_count})`,
    }));
  };

  //function to get the store list
  const getStoreList = async (id: string | null) => {
    if (!id) return;
    try {
      const response = await service?.movementService?.getMovementStoreList(id);
      if (response?.status === 201 || response?.status === 200) {
        setStoreData(getDropDown(response?.data?.data));
        setShowModal(constant.MOVEMENT_MODAL.BARCODE);
      }
    } catch (error) {
      console.error("error>>>", error);
    }
  };

  //handle the assign store in modal
  const handleSubmit = async () => {
    if (!selectedStoreId) return;
    try {
      const response = await service?.movementService?.assignStore(selectedStoreId);
      if (response?.status === 200 || response?.status === 201) {
        addToast(response?.data?.message, {
          appearance: 'success',
          autoDismiss: true,
          autoDismissTimeout: 3000,
        });
        handleClose()
        getPendingList()
      }
    } catch (error: any) {
      console.error("error>>>", error);
      addToast(error?.response?.data?.message || "", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });
    }
  };

  const handleClose=()=>{
    setShowModal('');
    setSelectedStoreId({
      procurement_item_id: '',
      pickup_store_id: ''
    });
    setStoreData([])
  };

  const handleAssignStorePopup=(id:string | null)=>{
    if(!id) return
    setSelectedStoreId((prevState)=>({...prevState,procurement_item_id:id}));
    getStoreList(id);
  }

  //Api to cancelled the procurement
  const handleCancelledApi=async(id:string | null)=>{
    if(!id) return;
    try {
      const response = await service?.movementService?.cancelledProcurement(id);
      if(response?.status === 200 || response?.status === 201){
        setShowModal('');
        getPendingList()
      }
    } catch (error:any) {
      console.error("error>>>", error);
      addToast(error?.response?.data?.message || "", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });
    }
  }

  const handleCancel=(id:string | null)=>{
    if(!id) return ;
    setShowModal(constant.MOVEMENT_MODAL.CANCELLED);
    setSelectedStoreId((prevState) => ({ ...prevState, procurement_item_id:id }))
  }

  useEffect(() => {
    getPendingList();
  }, [params]);

  useEffect(() => {
    setHeader("Movement - Pending");
  }, []);

  return (
    <Wrapper>
      <OrgMovementPending
        setSearch={(value: string) => updateParams("search", value)}
        pendingListing={pendingListing}
        setLimitPerPage={(value: number) => updateParams("limit", value)}
        setCurrentPage={(value: number) => updateParams("page", value)}
        currentPage={params?.page}
        limit={params?.limit}
        _handleEdit={(id: string | null) => handleAssignStorePopup(id)}
        handleCancel={(id:string | null) => handleCancel(id)}
      />
      {(showModal === constant?.MOVEMENT_MODAL.BARCODE) && (
        <CreateModal
          show={!!showModal}
          header={` Store`}
          handleSubmit={handleSubmit}
          submitBtnText={`Assign`}
          onHide={() => handleClose() }
        >
          <div>
            <form>
              <div className="row">
                <div className="col-12">
                  <Select
                    className={"w-100"}
                    options={storeData}
                    onChange={(e: any) => setSelectedStoreId((prevState) => ({ ...prevState, pickup_store_id: e.value }))}
                    placeholder={"Select"}
                    label={"Select Stores"}
                  />
                </div>
              </div>
            </form>
          </div>
        </CreateModal>
      )}
      {/* conform cancelled modal */}
      {(showModal === constant?.MOVEMENT_MODAL.CANCELLED) &&
        <ConfirmationModal
          show={!!showModal}
          handleConfirmItem={() => handleCancelledApi(selectedStoreId?.procurement_item_id)}
          onHide={() => {setShowModal(''); setSelectedStoreId((prevState) => ({ ...prevState, procurement_item_id:'' }))}}
          message={'cancel this procurement'} />
      }
    </Wrapper>
  );
};

export default Index;
